export function ErrorPage() {
    return (
        <div className="API-page">
            <h2>Hmm, det ser ikke ut som den siden eksisterer.</h2>
            <h2>Gå tilbake til hjemmesiden og prøv igjen...</h2>
        </div>
    )
}